import { Injectable } from '@angular/core';
import { HttpBackend } from '@angular/common/http';
import { CfgService } from 'src/app/cfg/cfg.service';

export class ApigeeCfg {
  public tokenEndpoint: string;
  public revokeEndpoint: string;
  public userInfoEndpoint: string;
  public grantType: string;
  public clientId: string;
  public url: string;
}

@Injectable({
  providedIn: 'root'
})
export class ApigeeCfgService extends CfgService<ApigeeCfg> {
  protected exclude: boolean = true;

  constructor(httpBackend: HttpBackend) {
    super(httpBackend);
  }

  protected getCfgFile(): string {
    return `/cfg/apigee.cfg.json`;
  }
}
